import { Either } from '../../util/conditionnalComponent'
import { AngleCollapse, AngleExpand } from '../icons'

export default Either('open', AngleCollapse, AngleExpand)
